// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  identityService: {
    url: "https://identitysvc.dev.medpt.com",
    apiVersion: "/api/v1/",
  },
  triportCoreService: {
    url: "https://triportcoresvc.dev.medpt.com",
    apiVersion: "/api/v1/"
  },
  triportDocumentService: {
    url: "https://triportdocumentsvc.dev.medpt.com",
    apiVersion: "/api/v1/"
  },
  triportLeaderBoardService: {
    url: "https://triportleaderboardsvc.dev.medpt.com",
    apiVersion: "/api/v1/"
  },
  triportNewsService: {
    url: "https://news.dev.medpt.com",
    apiVersion: "/api/v1/"
  },
  triportTrainingService: {
    url: "https://triporttrainingsvc.dev.medpt.com",
    apiVersion: "/api/v1/"
  },
  triportFormsService: {
    url: "https://triportformsvc.dev.medpt.com",
    apiVersion: "/api/v1/"
  },
  triportFaqService: {
    url: "https://triportfaqsvc.dev.medpt.com",
    apiVersion: "/api/v1/"
  },
  reportService: {
    url: "https://triportreportsvc.dev.medpt.com",
    apiVersion: "/api/v1/"
  },  
  usernotificationService: {
    url: "https://usernotificationsvc.dev.medpt.com",
    auth: "/api/auth",
  },
  idleTimeoutInMinutes: 20,
  storageService: {
    url: "https://storagesvc.dev.medpt.com",
    apiVersion: "/api/v3/"
  },
  userSessionService: {
    url: "https://usersessionsvc.dev.medpt.com",
    apiVersion: "/api/v1/",
  },
  regDocService: {
    url: "https://esafesvc.dev.medpt.com",
    apiVersion: "/api/v1/",
  },
  assetService: {
    url: "https://assetsvc.dev.medpt.com",
    apiVersion: "/api/v1/",
  },
  SSO: {
    COSMOSDBTableName: "usersession",
    clientId: "TriportSPA",
    secureAppUrl: "https://secure.dev.medpt.com"
  },
  toolService: {
    url: "https://triporttoolssvc.dev.medpt.com",
    apiVersion: "/api/v1/",
  },
  calendarService: {
    url: "https://triportcalendareventsvc.dev.medpt.com",
    apiVersion: "/api/v1/",
  },
  communicationService: {
    url: "https://triportcommunicationsvc.dev.medpt.com",
    apiVersion: "/api/v1/",
  },
  discussionService: {
    url: "https://discussionsvc.dev.medpt.com",
    apiVersion: "/api/v2/",
  },
  eSafeAssetService: {
    url: "https://mp-assetsvc-dev.azurewebsites.net",
    apiVersion: "/api/v1/",
  },
  commonCoreService: {
    url: "https://coresvc.dev.medpt.com",
    apiVersion: "/v2/"
  },
  viewerAppUrl: "https://commonviewersvc.dev.medpt.com/",
  scormAppUrl: "https://scorm.dev.medpt.com/",

  triportAdminAppUrl: "https://triportadmin.dev.medpt.com",
  cloudportAdminAppUrl: "https://cloudportadmin.dev.medpt.com",
  studystatAdminAppUrl: "https://studystatadmin.dev.medpt.com",
  raspberryAIAdminAppUrl: "https://raiadmin.dev.medpt.com",
  discussionAppUrl: "https://discussionadmin.dev.medpt.com",
  envPath: '.dev.medpt.com',
  myAppUrl: "https://apps.dev.medpt.com",
  iKey: "29e241b5-7d2c-4043-bfe9-d1a2fa2e5428",
  notificationDisappearInMilliseconds: 8000,  
  privacyUrl: "/shared/terms_privacy/Privacy.html",
  termsUrl: "/shared/terms_privacy/Terms.html",
  helpUrl: "/triport/help/",
  studyStatHelpUrl: "/studystat/help/",
  raspberryAIHelpUrl: "/raspberryai/help/",
  contactUrl: "/help/Contact.html",
  passwordExpirationDays: 90,
  cdnEndPoint: "https://mpcdn.dev.medpt.com",
  cdnSharedIconsFolder: "/shared/icons/",
  cdnSharedImagesFolder: "/shared/images/SVG/",
  cdnSharedLogosFolder: "/shared/logos/",
  cdnVersionPath: "/triport/triport-version.txt",
  eSafeAppUrl: "https://esafe.dev.medpt.com/#",
  masterLogEndPoint: "https://mp-masterlog-nonprod.servicebus.windows.net/masterlog-dev/messages",
  masterLogTokenGenerateEndPoint: "https://mp-tokenservice-dev.azurewebsites.net/api/MasterLogAuth",
  showSiteVerification:true,
  enableMasterLog:false,
  serverTimezone: "UTC"
};
